module.exports = __webpack_public_path__ + "assets/img/Record_btn.337e277a.png";